export const isPathMatch = (currentPath: string, targetPath: string, isTablet: boolean): boolean => {
  const normalizedCurrent = currentPath.replace(/\/$/, '')
  const normalizedTarget = targetPath.replace(/\/$/, '')

  // Exact match
  if (normalizedCurrent === normalizedTarget) {
    return true
  }

  // Hash route logic
  const [currentPathBase, currentHash] = normalizedCurrent.split('#')
  const [targetPathBase, targetHash] = normalizedTarget.split('#')

  if (currentHash && targetHash) {
    return currentPathBase === targetPathBase && currentHash === targetHash
  }

  if (targetHash && !currentHash) {
    return false
  }

  if (currentHash && !targetHash) {
    return currentPathBase === targetPathBase
  }

  // No hash involved, check base paths
  if (currentPathBase === targetPathBase) {
    return true
  }

  // Dynamic routes
  const currentSegments = currentPathBase.split('/').filter(Boolean)
  const targetSegments = targetPathBase.split('/').filter(Boolean)

  if (targetSegments.length <= currentSegments.length) {
    const targetBase = targetSegments.join('/')
    const currentBase = currentSegments.slice(0, targetSegments.length).join('/')
    if (targetBase === currentBase) {
      return true
    }
  }

  return false
}

interface NavigationItem {
  path: string
  children?: NavigationItem[]
}

export const isCurrentlySelected = (currentPath: string, menuItem: NavigationItem, isTablet: boolean): boolean => {
  // Check if this menu item exactly matches the current path
  if (isPathMatch(currentPath, menuItem.path, isTablet)) {
    // If this is a parent item and we're on a child route
    if (menuItem.children && menuItem.children.length > 0) {
      const isOnChildRoute = menuItem.children.some(child => isPathMatch(currentPath, child.path, isTablet))
      // In tablet view, parent should be selected even when on child route
      if (isOnChildRoute && !isTablet) {
        return false
      }
    }
    return true
  }

  // In tablet view, also check if any child route matches and select parent
  if (isTablet && menuItem.children && menuItem.children.length > 0) {
    const isOnChildRoute = menuItem.children.some(child => isPathMatch(currentPath, child.path, isTablet))
    if (isOnChildRoute) {
      return true
    }
  }

  return false
}

export const isPathActive = (currentPath: string, targetPath: string, exact: boolean = false) => {
  if (exact) {
    return currentPath === targetPath
  }
  return currentPath.startsWith(targetPath)
}
